export default "__VITE_ASSET__DzMGNgcp__"